import s from './timeline.module.scss'

export const Timeline = () => {
  return (
    <div className={s.container}>
      <h3 className={s.title}>Timeline</h3>
      <div className={s.timeline}>
        <div className={s.milestone}>
          <span className={s.label}>Registration</span>
          <span className={s.time}>Sep 15th, 2023</span>
        </div>
        <div className={s.milestone}>
          <span className={s.label}>Demo Submission</span>
          <span className={s.time}>Oct 15th, 2023</span>
        </div>
        <div className={s.milestone}>
          <span className={s.label}>Voting</span>
          <span className={s.time}>Oct 29th, 2023</span>
        </div>
        <div className={s.goal}>
          <span className={s.label}>Closing and Award</span>
          <span className={s.time}>Nov 13th, 2023</span>
        </div>
      </div>
    </div>
  )
}
